import { render, staticRenderFns } from "./ColumnOpportunity.vue?vue&type=template&id=781f5477&scoped=true"
import script from "./ColumnOpportunity.vue?vue&type=script&lang=js"
export * from "./ColumnOpportunity.vue?vue&type=script&lang=js"
import style0 from "./ColumnOpportunity.vue?vue&type=style&index=0&id=781f5477&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781f5477",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('781f5477')) {
      api.createRecord('781f5477', component.options)
    } else {
      api.reload('781f5477', component.options)
    }
    module.hot.accept("./ColumnOpportunity.vue?vue&type=template&id=781f5477&scoped=true", function () {
      api.rerender('781f5477', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/List/ColumnOpportunity.vue"
export default component.exports